// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"68b8bd55","488":"97e64078"}[chunkId] + ".chunk.js";
};